import { LitElement, html, css } from 'lit-element';

export default class CtvLoadWaiter extends LitElement {

	static get DomTag() {
		return 'ctv-load-waiter';
	}

	static get properties() {
		return {
			message: { type: String },
			show_top_right_hider: {type: String }
		};
	}

	constructor() {
		super();
		this.message = "";
		this.show_top_right_hider = false;
	}

	render() {
		if (this.message==null)
			this.message = "";
		return html`
			${Types.ToBool(this.show_top_right_hider)==true?html`<div class="top_right_hider"></div>`:``}
			<div class="${(this.message=="")?"":"wrapper"}">
				<div class="loader">
					<svg class="circular" viewBox="25 25 50 50">
						<circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
					</svg>
				</div>
				<div class="message">${this.message}</div>
			</div>
		`;
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);
		
		setTimeout(()=>{ 
			if (this.parentNode == null)
				return;
				
			let position = this.parentNode.style.position;
			if (position != null)
				position = position.toLowerCase()

			let vPositions = [
				"static",
				"relative",
				"fixed",
				"absolute",
				"sticky",
			]

			if (vPositions.indexOf(position) < 0)
				this.parentNode.style.position = "relative";
		},10);
	}

	remove() {
		if (this.hDelay != null)
			clearTimeout(this.hDelay);
		this.hDelay = null;
		
		super.remove();
	}

	/**
	 * Create and display a waiter
	 * @param {HTMLElement} elParent HTML element where to insert the waiter
	 * @param {string} message Message to show in the waiter
	 * @param {number} DelayBeforeShow Time in milliseconds after which to show the waiter
	 * @returns {CtvLoadWaiter} The waiter (so it can be removed later)
	 */
	static Show(elParent, message, DelayBeforeShow) {
		if (elParent == null)
			elParent = document.body;

		let el = elParent.querySelector(`:scope > ${CtvLoadWaiter.DomTag}`);
		if (el == null) {
			el = document.createElement(CtvLoadWaiter.DomTag)
			if (DelayBeforeShow != null)
				el.hDelay = setTimeout(()=>{ elParent.append(el); el.hDelay=null; },DelayBeforeShow)
			else
				elParent.append(el);
		}
		el.message = message;
		return el;
	}

	static get styles() {
		return css`	
		
			:host {
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				padding: 5%;
				display: flex;
				justify-content: center;
				flex-direction: column;
				align-items: center;
				justify-items: center;	
				background: rgba(255,255,255,0.6);
				border-radius:3px;
				z-index:18;
			}
			
			
			.top_right_hider {
				width: 75px;
				height: 24px;
				position: absolute;
				background: rgba(255, 255, 255, 0.6);
				top: -18px;
				right: 0;				
			}

			.wrapper {
			    padding: 25px 50px 7px;
			    border: 1px solid #dddddd;
			    border-radius: 8px;		
			    background: white;
				box-shadow: 1px 1px 3px #dedede;
				z-index:20;
			}
			
			.wrapper .message {
				line-height: 45px;
			}
			
			.loader {
			  position: relative;
			  margin: 0 auto;
			  width: 50px;
			  height: 50px;
			  &:before {
			    content: '';
			    display: block;
			    padding-top: 100%;
			  }
			}
			
			.circular {
			  animation: rotate 2s linear infinite;
			  height: 100%;
			  transform-origin: center center;
			  width: 100%;
			  position: absolute;
			  top: 0;
			  bottom: 0;
			  left: 0;
			  right: 0;
			  margin: auto;
			  
			}
			
			.path {
			  stroke-dasharray: 1, 200;
			  stroke-dashoffset: 0;
			  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
			  stroke-linecap: round;
			}
			
			@keyframes rotate {
			  100% {
			    transform: rotate(360deg);
			  }
			}
			
			@keyframes dash {
			  0% {
			    stroke-dasharray: 1, 200;
			    stroke-dashoffset: 0;
			  }
			  50% {
			    stroke-dasharray: 89, 200;
			    stroke-dashoffset: -35px;
			  }
			  100% {
			    stroke-dasharray: 89, 200;
			    stroke-dashoffset: -124px;
			  }
			}
			
			@keyframes color {
			  100%,
			  0% {
			    stroke: #ff7d02;
			  }
			  40% {
			    stroke: #ff7d02;
			  }
			  66% {
			    stroke: #ff7d02;
			  }
			  80%,
			  90% {
			    stroke: #ff7d02;
			  }
			}
			`;
	}
}
customElements.define(CtvLoadWaiter.DomTag, CtvLoadWaiter);